import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranscriptionNoSpeechDetected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 401,
	height: 309,
	viewBox: "0 0 401 309",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [
				/* @__PURE__ */ _jsxs("g", {
					opacity: .5,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M167.19 108.24C171.793 108.24 175.523 111.971 175.523 116.574V185.323C175.523 189.925 171.793 193.656 167.19 193.656C162.588 193.656 158.857 189.925 158.857 185.323V116.574C158.857 111.971 162.588 108.24 167.19 108.24Z",
						fill: "#6955DA"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M233.857 108.24C229.254 108.24 225.523 111.971 225.523 116.574V185.323C225.523 189.925 229.254 193.656 233.857 193.656C238.459 193.656 242.19 189.925 242.19 185.323V116.574C242.19 111.971 238.459 108.24 233.857 108.24Z",
						fill: "#6955DA"
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.191 96.935C192.191 92.3327 195.922 88.6017 200.524 88.6017C205.127 88.6017 208.858 92.3327 208.858 96.935V204.96C208.858 209.563 205.127 213.294 200.524 213.294C195.922 213.294 192.191 209.563 192.191 204.96V96.935Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M258.857 137.927C258.857 133.325 262.588 129.594 267.19 129.594C271.792 129.594 275.523 133.325 275.523 137.927V163.969C275.523 168.571 271.792 172.302 267.19 172.302C262.588 172.302 258.857 168.571 258.857 163.969V137.927Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.857 129.594C138.459 129.594 142.19 133.325 142.19 137.927V163.969C142.19 168.571 138.459 172.302 133.857 172.302C129.254 172.302 125.523 168.571 125.523 163.969V137.927C125.523 133.325 129.254 129.594 133.857 129.594Z",
					fill: "#6955DA"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_11327_274013)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M251.173 65.8074C246.171 47.1361 226.979 36.0557 208.307 41.0586C189.636 46.0616 178.556 65.2534 183.559 83.9247C188.562 102.596 207.753 113.676 226.425 108.673C245.096 103.67 256.176 84.4787 251.173 65.8074Z",
					fill: "url(#paint0_linear_11327_274013)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M250.689 65.9369C245.758 47.5323 226.84 36.6102 208.436 41.5417C190.031 46.4732 179.109 65.3908 184.041 83.7954C188.972 102.2 207.89 113.122 226.294 108.191C244.699 103.259 255.621 84.3415 250.689 65.9369Z",
					stroke: "url(#paint1_linear_11327_274013)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M220.709 67.1953L224.097 79.8395C224.731 82.2086 224.353 84.2142 223.053 85.4778C222.526 85.9882 221.881 86.338 221.165 86.5299C220.063 86.8252 218.779 86.7707 217.364 86.3379L212.667 84.895C212.347 84.8035 212.004 84.792 211.688 84.8769L208.437 85.7478L204.193 69.9081L207.443 69.0372C207.76 68.9523 208.051 68.771 208.282 68.5319L211.629 64.9337C213.304 63.1415 215.215 62.3933 216.986 62.834C218.744 63.2783 220.074 64.8262 220.709 67.1953Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.195 69.9082L208.439 85.7479L207.751 85.9324C204.417 86.8256 202.095 85.4845 201.202 82.1513L199.725 76.6419C198.832 73.3086 200.173 70.9859 203.506 70.0928L204.195 69.9082Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.674 67.4088C232.511 67.8921 232.798 68.9623 232.315 69.7993L231.44 71.3149L232.955 72.1899C233.792 72.6731 234.079 73.7434 233.596 74.5804C233.113 75.4174 232.042 75.7042 231.205 75.221L229.69 74.346L228.815 75.8615C228.332 76.6985 227.261 76.9853 226.424 76.5021C225.587 76.0188 225.3 74.9485 225.784 74.1115L226.659 72.596L225.143 71.721C224.306 71.2377 224.019 70.1674 224.503 69.3304C224.986 68.4934 226.056 68.2066 226.893 68.6899L228.409 69.5649L229.284 68.0493C229.767 67.2123 230.837 66.9256 231.674 67.4088Z",
					fill: "#6955DA"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_11327_274013)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M118.22 198.978C113.932 182.974 97.4818 173.476 81.4778 177.764C65.4738 182.053 55.9763 198.503 60.2646 214.507C64.5528 230.511 81.0029 240.008 97.0069 235.72C113.011 231.432 122.508 214.982 118.22 198.978Z",
					fill: "url(#paint2_linear_11327_274013)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.738 199.108C113.521 183.37 97.3453 174.031 81.6081 178.248C65.8708 182.465 56.5317 198.641 60.7484 214.378C64.9652 230.115 81.1412 239.454 96.8784 235.238C112.616 231.021 121.955 214.845 117.738 199.108Z",
					stroke: "url(#paint3_linear_11327_274013)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M84.0119 215.909C83.2945 215.494 83.0487 214.577 83.4629 213.859L92.4629 198.271C92.8771 197.554 93.7945 197.308 94.5119 197.722C95.2293 198.136 95.4752 199.054 95.0609 199.771L86.0609 215.359C85.6467 216.077 84.7293 216.323 84.0119 215.909Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.3789 212.048C98.7931 211.33 98.5473 210.413 97.8298 209.999L82.176 200.961C81.4586 200.547 80.5412 200.793 80.127 201.51C79.7128 202.227 79.9586 203.145 80.676 203.559L96.3298 212.597C97.0473 213.011 97.9646 212.765 98.3789 212.048Z",
					fill: "#6955DA"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_11327_274013)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M338.509 168.131C341.646 156.108 334.442 143.817 322.418 140.68C310.394 137.543 298.103 144.747 294.966 156.771C291.829 168.795 299.034 181.086 311.057 184.223C323.081 187.36 335.372 180.155 338.509 168.131Z",
					fill: "url(#paint4_linear_11327_274013)",
					fillOpacity: .6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M338.027 168.005C341.094 156.248 334.05 144.231 322.293 141.164C310.537 138.097 298.519 145.141 295.452 156.897C292.385 168.654 299.429 180.671 311.186 183.739C322.942 186.806 334.959 179.762 338.027 168.005Z",
					stroke: "url(#paint5_linear_11327_274013)",
					strokeOpacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M318.727 154.831C314.519 153.733 310.217 156.255 309.119 160.463C308.021 164.672 310.543 168.973 314.751 170.071C318.96 171.169 323.261 168.648 324.359 164.439C325.457 160.231 322.936 155.929 318.727 154.831ZM319.295 152.654C313.885 151.243 308.354 154.485 306.942 159.895C305.531 165.306 308.772 170.837 314.183 172.248C319.594 173.66 325.125 170.418 326.536 165.007C327.948 159.597 324.706 154.066 319.295 152.654Z",
					fill: "#6955DA"
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .5,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M315.388 163.334C315.231 163.935 315.591 164.55 316.193 164.707C316.794 164.864 317.408 164.503 317.565 163.902L319.073 158.124C319.23 157.523 318.869 156.909 318.268 156.752C317.667 156.595 317.052 156.955 316.896 157.556L315.388 163.334Z",
						fill: "#6955DA"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M314.484 166.799C314.327 167.4 314.687 168.015 315.289 168.171C315.89 168.328 316.504 167.968 316.661 167.367L316.719 167.144C316.876 166.543 316.516 165.928 315.915 165.772C315.314 165.615 314.699 165.975 314.542 166.576L314.484 166.799Z",
						fill: "#6955DA"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_11327_274013",
				x: 134.355,
				y: 15.8573,
				width: 166.02,
				height: 166.018,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274013"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274013",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_11327_274013",
				x: 11.2344,
				y: 152.735,
				width: 156.016,
				height: 156.015,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274013"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274013",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_11327_274013",
				x: 246.232,
				y: 115.946,
				width: 141.012,
				height: 141.011,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11327_274013"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_11327_274013",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_11327_274013",
				x1: 208.307,
				y1: 41.0586,
				x2: 226.425,
				y2: 108.673,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_11327_274013",
				x1: 208.236,
				y1: 41.2291,
				x2: 226.353,
				y2: 108.844,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_11327_274013",
				x1: 81.4778,
				y1: 177.764,
				x2: 97.0069,
				y2: 235.72,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_11327_274013",
				x1: 81.4079,
				y1: 177.935,
				x2: 96.937,
				y2: 235.891,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_11327_274013",
				x1: 322.418,
				y1: 140.68,
				x2: 311.057,
				y2: 184.223,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#C9C9C9",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EAEBF0",
					stopOpacity: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_11327_274013",
				x1: 322.585,
				y1: 140.609,
				x2: 311.224,
				y2: 184.152,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6C72",
					stopOpacity: .25
				})]
			})
		] })
	]
});
export default SvgTranscriptionNoSpeechDetected;
